'use strict';

export const footer = (() => {
  const replaceHearts = () => {
    const _title = document.querySelector('.footer__title');
    if (!_title) return;
    const text = _title.innerHTML;
    const splited = text.split("♥");
    let res = '';
    for (let i = 0, l = splited.length; i < l; i++) {
      const txt = splited[i];
      if (i > 0) {
        res += `<svg class="heart ${i > 1 ? 'green' : ''}">
                    <use href="#icon-heart"></use>
                </svg>`;
      }
      res += txt;
    }
    if (res !== '') {
      _title.innerHTML = res;
    }
  };

  const replaceEmail = () => {
    const _email = document.querySelector('.footer__hello__email');
    const text = _email.innerHTML;
    const splited = text.split("@");
    let res = '';
    for (let i = 0, l = splited.length; i < l; i++) {
      const txt = splited[i];
      if (i > 0) {
        res += `@</br>`;
      }
      res += txt;
    }
    if (res !== '') {
      _email.innerHTML = res;
    }
  };

  const init = () => {
    replaceEmail();
    replaceHearts();
  };

  return {
    init
  }
})();
